import { useAuth0 } from '@auth0/auth0-react';

/**
 * Shown when an API call failed for an AUTH reason (expired or stale Auth0 session, API 401).
 * This is deliberately distinct from the "Premium Subscription Required" paywall: a paying
 * customer whose token died must be told to sign in again, never to upgrade (#164).
 */
export function SignInAgain({ error }: { error?: unknown }) {
  const { loginWithRedirect, logout } = useAuth0();
  const message = error instanceof Error ? error.message : 'Your session has expired.';

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-bold text-white mb-2">You're signed out</h2>
        <p className="text-gray-400 mb-6">{message} Sign back in to continue; your subscription is unaffected.</p>
        <button
          onClick={() =>
            loginWithRedirect({ appState: { returnTo: window.location.pathname + window.location.search } })
          }
          className="inline-flex items-center px-6 py-3 bg-obdai-gradient text-white font-medium rounded-lg hover:opacity-90 transition"
        >
          Sign in again
        </button>
        <p className="text-gray-500 mt-6 text-sm">
          Still looping?{' '}
          <button
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            className="underline hover:text-gray-300"
          >
            Reset this browser's sign-in
          </button>
        </p>
      </div>
    </div>
  );
}
